/*import React, { useEffect, useState } from 'react';
import './Payment.css';
import axios from './axios';
import CheckoutProduct from './CheckoutProduct';
import { useStateValue } from './StateProvider';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import { useNavigate } from "react-router-dom";
import { getBasketTotal } from './reducer';
import { db } from "./firebase";

function Payment() {
    const [{basket, user }, dispatch] = useStateValue();
    const navigate = useNavigate();

    const stripe = useStripe();
    const elements = useElements();

    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [error, setError] = useState(null);
    const [disabled, setDisable] = useState(true);
    const [clientSecret, setClientSecret] = useState(true);

    const totalInCents = Math.round(getBasketTotal(basket) * 100);

    useEffect(() => {
      const getClientSecret = async () => {
          const responce = await axios({
            method: 'post',
            url: `/payments/create?total=${totalInCents}`
          });
          
          setClientSecret(responce.data.clientSecret)
      }

      getClientSecret();
    }, [basket])


    const handleSubmit = async (event) => {
      event.preventDefault();
      setProcessing(true);

      const payload = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement)
        }
      }).then(({ paymentIntent }) => {
        
        db.collection('users')
        .doc(user?.uid)
        .collection('orders')
        .doc(paymentIntent.id).set({
          basket: basket,
          amount: paymentIntent.amount,
          created: paymentIntent.created
        })

        setSucceeded(true)
        setError(null)
        setProcessing(false)

        dispatch({
          type: 'EMPTY_BASKET'
        })

        navigate('/orders', { replace: true })
      })
    }


    const handleChange = event => {
      setDisable(event.empty);
      setError(event.error ? event.error.message: "");
    }

  return (
    <div className='payment'>
      <div className='payment_container'>
        <h1>
            Acquista ({basket?.length} articoli)
        </h1>

        <div className='payment_section'>
            <h3>Controlla gli articoli e effettua il pagamento</h3>
            <div className='payment_items'>
                {basket.map(item => (
                    <CheckoutProduct 
                    id = {item.id}
                    title = {item.title}
                    description = {item.description}
                    image = {item.image}
                    price = {item.price}
                    quantity={item.quantity}
                    size = {item.size}
                  />
                ))}
            </div>
        </div>

        <div className='payment_section'>
            <div className='payment_title'>
                <h3>Esegui pagamento</h3>
            </div>
            <div className='payment_details'>
                  <form onSubmit={handleSubmit}>
                      <CardElement onChange={handleChange}/>
                      <div className='payment_priceContainer'>
                        <CurrencyFormat renderText={(value) => (
                            <>
                            <h3>Totale dell'ordine: {value}</h3>
                            </>
                          )}
                          decimalScale={2}
                          value={getBasketTotal(basket)}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'€'}
                        />
                        <button disabled={processing || disabled || succeeded} >
                        <span>{processing ? <p>Elaborazione</p>: "acquista ora"}</span>
                        </button>
                      </div>

                      {error && <div>{error}</div>}
                  </form>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Payment*/



import React, { useEffect, useState, useRef } from 'react';
import './Payment.css';
import axios from './axios';
import CheckoutProduct from './CheckoutProduct';
import { useStateValue } from './StateProvider';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import { useNavigate } from "react-router-dom";
import { getBasketTotal } from './reducer';
import { db, auth } from "./firebase";
import { doc, setDoc, collection, getDocs, deleteDoc } from "firebase/firestore";
import { toast } from 'react-toastify';

// FUNZIONE DI CALCOLO SPEDIZIONE
function calcolaSpedizione(peso, spedizioneVeloce) {
  const lunghezza = 40;
  const altezza = 30;
  const profondita = 30;
  const sommaMisure = lunghezza + altezza + profondita;

  const fascePesoReali = [
    { max: 1, standard: 5.65, veloceExtra: 1.00 },
    { max: 2, standard: 5.90, veloceExtra: 1.00 },
    { max: 3, standard: 6.70, veloceExtra: 1.00 },
    { max: 5, standard: 7.30, veloceExtra: 1.00 },
    { max: 10, standard: 10.40, veloceExtra: 1.00 },
    { max: 15, standard: 11.70, veloceExtra: 1.00 },
    { max: 20, standard: 12.30, veloceExtra: 1.00 },
    { max: 30, standard: 14.80, veloceExtra: 1.00 },
    { max: 40, standard: 30.30, veloceExtra: 1.60 },
    { max: 50, standard: 34.30, veloceExtra: 1.60 }
  ];

  const fasciaReale = fascePesoReali.find(f => peso <= f.max);
  let base;
  let extraVeloce;

  if (fasciaReale) {
    base = fasciaReale.standard;
    extraVeloce = fasciaReale.veloceExtra;
  } else {
    const incrementoPerKg = 0.40;
    const base50 = 34.30;
    const kgOltre50 = peso - 50;

    base = base50 + kgOltre50 * incrementoPerKg;
    extraVeloce = 1.60;
  }

  let extraDimensioni = 0;
  if (peso > 30) {
    if (sommaMisure > 150 && sommaMisure <= 220) extraDimensioni = 9;
    else if (sommaMisure > 220) extraDimensioni = 40;
  }

  const extra = spedizioneVeloce ? extraVeloce : 0;
  return parseFloat((base + extraDimensioni + extra).toFixed(2));
}

function Payment() {
  const [{ basket, user }, dispatch] = useStateValue();
  const navigate = useNavigate();

  const stripe = useStripe();
  const elements = useElements();

  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [disabled, setDisable] = useState(true);
  const [clientSecret, setClientSecret] = useState('');

  // STATO SPEDIZIONE
  const [shippingOption, setShippingOption] = useState('no');
  const isPaymentSuccessful = useRef(false);

  // 1. Calcolo del Peso Totale dal Carrello (Assicurati che gli articoli nel basket abbiano la proprietà 'peso' o 'weight')
  const totalWeight = basket?.reduce((acc, item) => acc + (Number(item.peso || item.weight || 1) * (item.quantity || 1)), 0) || 0;

  // 2. Calcolo Spesa di Spedizione e Totale Finale
  const shippingCost = calcolaSpedizione(totalWeight, shippingOption === 'si');
  const itemsTotal = getBasketTotal(basket);
  const grandTotal = Number(itemsTotal) + Number(shippingCost);
  //const totalInCents = Math.round(grandTotal * 100);

  useEffect(() => {
    if (isPaymentSuccessful.current) return;

    if (!user) {
      toast.error("Devi prima effettuare l'accesso per procedere al pagamento!", { autoClose: 5000 });
      navigate('/checkout');
      return;
    }

    if (!basket || basket.length === 0) {
      toast.warn("Il tuo carrello è vuoto!", { autoClose: 5000 });
      navigate('/checkout');
      return;
    }

    // Chiamata backend ogni volta che varia il totale complessivo (compresa la spedizione)
    const getClientSecret = async () => {
      try {
        const currentUser = auth.currentUser;
        const idToken = currentUser ? await currentUser.getIdToken() : null;

        const response = await axios.post(
          "/payments/create",
          {
            items: basket,
            shippingOption,
          },
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          }
        );

        setClientSecret(response.data.clientSecret);

      } catch (err) {
        console.error("Errore Backend Stripe:", err);
        setError("Impossibile contattare il server di pagamento.");
      }
    };

    /*if (totalInCents > 0) {
      getClientSecret();
    }*/

    getClientSecret();
  }, [basket, user, shippingOption, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!shippingOption) {
      setError("Seleziona una tipologia di spedizione prima di proseguire.");
      return;
    }

    if (!stripe || !elements || !clientSecret) return;

    setProcessing(true);

    try {
      const { paymentIntent, error: stripeError } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement)
        }
      });

      if (stripeError) {
        setError(`Pagamento fallito: ${stripeError.message}`);
        setProcessing(false);
        return;
      }

      isPaymentSuccessful.current = true;

      /*if (user) {
        const orderRef = doc(db, 'users', user.uid, 'orders', paymentIntent.id);
        await setDoc(orderRef, {
          basket: basket,
          amount: paymentIntent.amount / 100,
          itemsTotal: itemsTotal,
          shippingCost: shippingCost,
          isUrgent: shippingOption === 'si',
          created: paymentIntent.created
        });

        const cartRef = collection(db, "users", user.uid, "carrello");
        const cartSnap = await getDocs(cartRef);
        const deletePromises = cartSnap.docs.map((docSnap) => deleteDoc(docSnap.ref));
        await Promise.all(deletePromises);
      }*/

      setSucceeded(true);
      setError(null);
      setProcessing(false);

      dispatch({ type: 'EMPTY_BASKET' });
      toast.success("Pagamento completato con successo!", { autoClose: 5000 });
      navigate('/orders', { replace: true });

    } catch (err) {
      console.error("Errore durante il pagamento:", err);
      setError(`Pagamento fallito: ${err.message}`);
      setProcessing(false);
    }
  };

  const handleChange = event => {
    setDisable(event.empty);
    setError(event.error ? event.error.message : "");
  };

  if ((!user || !basket || basket.length === 0) && !isPaymentSuccessful.current) {
    return null;
  }

  return (
    <div className='payment'>
      <div className='payment_container'>
        <h1>Acquista ({basket?.length} articoli)</h1>

        <div className='payment_section'>
          <h3>Controlla gli articoli ed effettua il pagamento</h3>
          <div className='payment_items'>
            {basket.map((item, index) => (
              <CheckoutProduct 
                key={index}
                id={item.id}
                title={item.title}
                description={item.description}
                image={item.image}
                price={item.price}
                quantity={item.quantity}
                size={item.size}
              />
            ))}
          </div>
        </div>

        <div className='payment_section'>
          <div className='payment_title'>
            <h3>Esegui pagamento</h3>
          </div>
          <div className='payment_details'>
            <form onSubmit={handleSubmit}>
              
              {/* Selezione Spedizione collocata prima del riepilogo prezzi */}
              <div style={{ margin: '15px 0', padding: '15px', border: '1px solid #ddd', borderRadius: '8px' }}>
                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                  Modalità di spedizione <span style={{ color: '#d32f2f' }}>(Obbligatorio)</span>
                </p>
                
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginBottom: '8px' }}>
                  <input 
                    type="radio" 
                    name="shippingUrgency" 
                    value="no"
                    checked={shippingOption === 'no'}
                    onChange={(e) => setShippingOption(e.target.value)}
                  />
                  <span style={{ marginLeft: '8px' }}>Spedizione Standard</span>
                </label>

                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input 
                    type="radio" 
                    name="shippingUrgency" 
                    value="si"
                    checked={shippingOption === 'si'}
                    onChange={(e) => setShippingOption(e.target.value)}
                  />
                  <span style={{ marginLeft: '8px' }}>Spedizione Urgente</span>
                </label>
              </div>

              {/* RIEPILOGO TRASPARENTE DEI COSTI */}
              <div style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px', marginBottom: '15px' }}>
                <p style={{ display: 'flex', justifyContent: 'space-between', margin: '4px 0' }}>
                  <span>Subtotale articoli:</span>
                  <span>€{itemsTotal.toFixed(2)}</span>
                </p>
                <p style={{ display: 'flex', justifyContent: 'space-between', margin: '4px 0' }}>
                  <span>Spese di spedizione ({totalWeight} kg):</span>
                  <span>€{shippingCost.toFixed(2)}</span>
                </p>
                <hr style={{ margin: '8px 0', border: '0', borderTop: '1px solid #ccc' }} />
                <h3 style={{ display: 'flex', justifyContent: 'space-between', margin: '4px 0', color: '#111' }}>
                  <span>Totale dell'ordine:</span>
                  <span>€{grandTotal.toFixed(2)}</span>
                </h3>
              </div>

              <CardElement onChange={handleChange}/>

              <div className='payment_priceContainer' style={{ marginTop: '15px' }}>
                <button disabled={processing || disabled || succeeded || !clientSecret}>
                  <span>{processing ? "Elaborazione..." : `Paga €${grandTotal.toFixed(2)}`}</span>
                </button>
              </div>

              {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;